export default function() {
  /* eslint-disable */
  let reg = new RegExp("[a-zA-Z0-9!@#$%^&*]{8,16}");
  return reg.test(this.password);
}
